/* Beden tablosu penceresi (snippets/size-guide.liquid): sekmeler, seçili beden satırı, WhatsApp mesajı.
   Ürün sayfasında ve hızlı bakışta (iç içe pencere) çalışır. */
(function () {
  'use strict';
  var norm = function (value) { return String(value || '').trim().toLocaleUpperCase('tr-TR'); };
  var tokens = function (value) { return norm(value).split(/[^0-9A-ZÇĞİÖŞÜ]+/).filter(Boolean); };

  function selectedSize(modal) {
    var scope = modal.closest('.qv, .qv-body, .shopify-section, main') || document;
    var node = scope.querySelector('.pdp-option--size .pdp-size.is-selected, .qv-size[aria-pressed="true"]');
    if (!node) return '';
    return node.getAttribute('data-value') || node.getAttribute('data-qv-value') || '';
  }

  function matches(rowLabel, size) {
    if (!size) return false;
    if (norm(rowLabel) === norm(size)) return true;
    var wanted = tokens(size);
    var have = tokens(rowLabel);
    return wanted.length > 0 && wanted.every(function (part) { return have.indexOf(part) > -1; });
  }

  function showTab(modal, name) {
    modal.querySelectorAll('[data-sg-tab]').forEach(function (tab) {
      var active = tab.getAttribute('data-sg-tab') === name;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    modal.querySelectorAll('[data-sg-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-sg-panel') !== name;
    });
  }

  function refresh(modal) {
    var size = selectedSize(modal);
    var wrap = modal.querySelector('[data-sg-current-wrap]');
    var current = modal.querySelector('[data-sg-current]');
    if (wrap && current) { current.textContent = size; wrap.hidden = !size; }
    var rows = modal.querySelectorAll('tr[data-sg-size]');
    var hit = null;
    rows.forEach(function (row) {
      var on = !hit && matches(row.getAttribute('data-sg-size'), size);
      row.classList.toggle('is-current', on);
      if (on) { row.setAttribute('aria-current', 'true'); hit = row; } else { row.removeAttribute('aria-current'); }
    });
    var missing = modal.querySelector('[data-sg-missing]');
    if (missing) missing.hidden = !(size && rows.length && !hit);
    if (hit && hit.scrollIntoView) hit.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    var ask = modal.querySelector('[data-sg-ask]');
    if (ask) {
      var text = ask.getAttribute('data-wa-text') || '';
      if (size) text += ' ' + (ask.getAttribute('data-wa-size-label') || '') + ' ' + size;
      ask.href = 'https://wa.me/' + ask.getAttribute('data-wa-number') + '?text=' + encodeURIComponent(text.trim());
    }
  }

  function setup(modal) {
    if (modal.dataset.sgReady) return;
    modal.dataset.sgReady = '1';
    modal.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-sg-tab]');
      if (tab && modal.contains(tab)) showTab(modal, tab.getAttribute('data-sg-tab'));
      /* Hızlı bakış penceresinin içindeyken tıklama dış pencereyi kapatmasın. */
      if (modal.parentElement && modal.parentElement.closest('modal-dialog, drawer-panel')) event.stopPropagation();
    });
    /* İç içe açıldığında kapanma olayı dış pencereye (hızlı bakış) ulaşmasın; yoksa hızlı bakış içeriğini temizler. */
    modal.addEventListener('dialog:closed', function (event) {
      if (event.target === modal && modal.parentElement && modal.parentElement.closest('modal-dialog, drawer-panel')) event.stopPropagation();
    });
    modal.addEventListener('keydown', function (event) {
      var tab = event.target.closest('[data-sg-tab]');
      if (!tab || (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft')) return;
      var tabs = Array.prototype.slice.call(modal.querySelectorAll('[data-sg-tab]'));
      var next = tabs[(tabs.indexOf(tab) + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      showTab(modal, next.getAttribute('data-sg-tab'));
      next.focus();
    });
  }

  document.addEventListener('dialog:opened', function (event) {
    var modal = event.target;
    if (!modal || !modal.matches || !modal.matches('[data-size-guide]')) return;
    setup(modal);
    refresh(modal);
  });
})();
